/*
  Turn backend errors into something safe to show a customer.

  Raw Postgres/PostgREST messages leak schema details — column names,
  constraint names, policy names — which hand an attacker a free map of
  the database. Auth messages are safe and genuinely useful, so those
  pass through.
*/

const SAFE_PATTERNS = [
  /invalid login credentials/i,
  /email not confirmed/i,
  /user already registered/i,
  /password should be at least/i,
  /rate limit|too many requests/i,
  /current password is incorrect/i,
  /unable to validate email/i,
  /email address .* is invalid/i,
];

export const friendlyError = (error, fallback = 'Something went wrong. Please try again.') => {
  const message = typeof error === 'string' ? error : error?.message || '';
  if (!message) return fallback;

  if (SAFE_PATTERNS.some((re) => re.test(message))) return message;

  // Recognisable classes of failure, described without internals.
  if (/row-level security|violates row/i.test(message)) {
    return "You don't have permission to do that.";
  }
  if (/duplicate key|already exists|unique constraint/i.test(message)) {
    return 'That record already exists.';
  }
  if (/network|fetch failed|failed to fetch/i.test(message)) {
    return 'Network problem — please check your connection and try again.';
  }

  // Anything else: log for us, stay vague for them.
  console.error('[suppressed error]', message);
  return fallback;
};
